import DgCodemirror from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgCodemirror.install = function (Vue) {
  Vue.component(DgCodemirror.name, DgCodemirror)
}
export default DgCodemirror

export { DgCodemirror }
